export enum dropPressIdsEnum {
    CURRENCY_SELECT = "currencySelectID",
    SUBMIT = "formSubmitID",
    CANCEL = "formCancelID",
}
